import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  AttachmentManager,
  FilterButton,
  VendorCorrectiveActions,
  VendorCurrentOrders,
  VendorInfo,
  VendorInventory,
  VendorInvoiceSummary,
  VendorTypeahead
} from ".";
import { DesktopContainer } from "../layouts";
import { constants, filterHelpers } from '../utils';

export default function VendorDashboard(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { vendorId } = useParams();
  const [filters, setFilters] = useState([]);
  const [vendor, setVendor] = useState(location.state);

  useEffect(() => {
    if (location.state !== vendor) {
      setVendor(location.state)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  useEffect(() => {
    if (vendorId) {
      const json = decodeURI(vendorId);
      const opt = JSON.parse(json);
      setVendor(opt)
    } else {
      if (location.state !== vendor) {
        setVendor(location.state)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  function onFilterChange(changedFilter) {
    const filterChanges = filterHelpers.getFilters(filters, changedFilter);
    setFilters(filterChanges);
  }

  return (
    document.title = `Vendor Dashboard`,
    <DesktopContainer screenName="Vendor Dashboard">
      <div className="filter-header sticky-top">
        <Row className="mb-2">
          <Col xs={2} md={2} lg={3} className="text-end">
            <div className="h4 pt-1 text-white align-middle">
              Vendor:
            </div>
          </Col>
          <Col xs={8} md={8} lg={6}>
            <VendorTypeahead
              value={vendor}
              onChange={opt => navigate(constants.ENDPOINTS.vendorDashboard, { state: opt, replace: true })}
            />
          </Col>
        </Row>
        <div className="dashboard-button-container">
          <FilterButton
            filterName="vendorInfo"
            displayName="Vendor Information"
            value={filterHelpers.getValue(filters, "vendorInfo")}
            onChangeCallback={onFilterChange}
          />
          <FilterButton
            filterName="currentPOs"
            displayName="Current Purchase Orders"
            value={filterHelpers.getValue(filters, "currentPOs")}
            onChangeCallback={onFilterChange}
          />
          <FilterButton
            filterName="currentInventory"
            displayName="Current Inventory"
            value={filterHelpers.getValue(filters, "currentInventory")}
            onChangeCallback={onFilterChange}
          />
          <FilterButton
            filterName="correctiveActions"
            displayName="Corrective Action History"
            value={filterHelpers.getValue(filters, "correctiveActions")}
            onChangeCallback={onFilterChange}
          />
          <FilterButton
            filterName="invoiceSummary"
            displayName="Invoice Summary"
            value={filterHelpers.getValue(filters, "invoiceSummary")}
            onChangeCallback={onFilterChange}
          />
          <FilterButton
            filterName="attachments"
            displayName="Attachments"
            value={filterHelpers.getValue(filters, "attachments")}
            onChangeCallback={onFilterChange}
          />
        </div>
      </div>
      {vendor &&
        <>
          {filterHelpers.getValue(filters, "vendorInfo") && (
            <Card className="dashboard-card">
              <CardBody>
                <VendorInfo vendorName={vendor.label} vendorId={vendor.value} />
              </CardBody>
            </Card>
          )}
          {filterHelpers.getValue(filters, "currentPOs") && (
            <Card className="dashboard-card">
              <CardBody>
                <VendorCurrentOrders vendorName={vendor.label} vendorId={vendor.value} />
              </CardBody>
            </Card>
          )}
          {filterHelpers.getValue(filters, "currentInventory") && (
            <Card className="dashboard-card">
              <CardBody>
                <VendorInventory vendorName={vendor.label} vendorId={vendor.value} />
              </CardBody>
            </Card>
          )}
          {filterHelpers.getValue(filters, "correctiveActions") && (
            <Card className="dashboard-card">
              <CardBody>
                <VendorCorrectiveActions vendorName={vendor.label} vendorId={vendor.value} />
              </CardBody>
            </Card>
          )}
          {filterHelpers.getValue(filters, "invoiceSummary") && (
            <Card className="dashboard-card">
              <CardBody>
                <VendorInvoiceSummary vendorName={vendor.label} vendorId={vendor.value} />
              </CardBody>
            </Card>
          )}
          {filterHelpers.getValue(filters, "attachments") && (
            <Card className="dashboard-card">
              <CardBody>
                <AttachmentManager attachmentTypeId={constants.ATTACHMENT_TYPES.Vendor} contextName={vendor.value} attachmentKey={vendor.value} />
              </CardBody>
            </Card>
          )}
        </>
      }
    </DesktopContainer>
  );
}